import _slicedToArray from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Alert from '@/components/shared/Alert';
import Panel from '@/components/shared/Panel';
import WebSourceEditForm from '@/components/web-source-management/WebSourceEditForm';
import { fieldNames as _fieldNames } from '@/constants/web-source-management/webSourceFieldNames.const';
import { SurveyManagementOverview, WebSourceManagement } from '@/services/ResourceService';
import ScrollAnimatorService from '@/services/ScrollAnimatorService';
import { EMBEDDED_TYPE } from '@/constants/embeddedTypes.const';
import { getValidationState } from '@/services/utils/LasUtils';
import { ERROR_TYPES } from '@/constants/errorTypes.const';
export default {
  name: 'WebSourceEditSubPage',
  components: {
    Alert: Alert,
    WebSourceEditForm: WebSourceEditForm,
    Panel: Panel
  },
  props: {
    isCreation: {
      type: Boolean,
      required: true
    },
    sourceId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      isLoading: true,
      isSubmitting: false,
      successfullySaved: false,
      validationErrorOccurred: false,
      serverErrorOccurred: false,
      rawWebSourceData: null,
      editedWebSourceData: {},
      activeSurveys: null,
      validationErrors: [],
      defaultLanguage: 'DE'
    };
  },
  computed: {
    fieldNames: function fieldNames() {
      return _fieldNames;
    },
    activeSurveyLanguages: function activeSurveyLanguages() {
      return _toConsumableArray(new Set(this.activeSurveys.flatMap(function (survey) {
        return survey.enabledLanguages;
      })));
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.isLoading = true;
            _context.prev = 1;
            _context.next = 4;
            return _this.getActiveSurveysByCompany();
          case 4:
            if (!_this.sourceId) {
              _context.next = 7;
              break;
            }
            _context.next = 7;
            return _this.loadWebSourceData();
          case 7:
            _this.mapWebSourceData();
            _this.isLoading = false;
            _context.next = 15;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
            _this.isLoading = false;
            _this.serverErrorOccurred = true;
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 11]]);
    }))();
  },
  methods: {
    getActiveSurveysByCompany: function getActiveSurveysByCompany() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return SurveyManagementOverview.getActiveSurveys(_this2.$store.state.general.companyId);
            case 2:
              response = _context2.sent;
              _this2.activeSurveys = response.data;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    loadWebSourceData: function loadWebSourceData() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return WebSourceManagement.getWebSourceById(_this3.$store.state.general.companyId, _this3.sourceId);
            case 2:
              response = _context3.sent;
              _this3.rawWebSourceData = response.data;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    mapWebSourceData: function mapWebSourceData() {
      var _this$rawWebSourceDat, _this$rawWebSourceDat2, _this$rawWebSourceDat3, _this$rawWebSourceDat4, _this$rawWebSourceDat5, _this$rawWebSourceDat6, _this$rawWebSourceDat7, _this$rawWebSourceDat8, _this$rawWebSourceDat9, _this$rawWebSourceDat10, _this$rawWebSourceDat11, _this$rawWebSourceDat12, _this$rawWebSourceDat13, _this$rawWebSourceDat14, _this$rawWebSourceDat15, _this$rawWebSourceDat16, _this$rawWebSourceDat17, _this$rawWebSourceDat18, _this$rawWebSourceDat19, _this$editedWebSource;
      this.editedWebSourceData = (_this$editedWebSource = {}, _defineProperty(_this$editedWebSource, this.fieldNames.WEB_SOURCE_ID, ((_this$rawWebSourceDat = this.rawWebSourceData) === null || _this$rawWebSourceDat === void 0 ? void 0 : _this$rawWebSourceDat.webSourceId) || null), _defineProperty(_this$editedWebSource, this.fieldNames.LOCATIONS, ((_this$rawWebSourceDat2 = this.rawWebSourceData) === null || _this$rawWebSourceDat2 === void 0 ? void 0 : _this$rawWebSourceDat2.locationIds) || []), _defineProperty(_this$editedWebSource, this.fieldNames.DESCRIPTION, ((_this$rawWebSourceDat3 = this.rawWebSourceData) === null || _this$rawWebSourceDat3 === void 0 ? void 0 : _this$rawWebSourceDat3.description) || ''), _defineProperty(_this$editedWebSource, this.fieldNames.EMBEDDED_TYPE, ((_this$rawWebSourceDat4 = this.rawWebSourceData) === null || _this$rawWebSourceDat4 === void 0 ? void 0 : _this$rawWebSourceDat4.embeddedType) || EMBEDDED_TYPE.NOT_EMBEDDED), _defineProperty(_this$editedWebSource, this.fieldNames.USE_RECAPTCHA, ((_this$rawWebSourceDat5 = this.rawWebSourceData) === null || _this$rawWebSourceDat5 === void 0 ? void 0 : _this$rawWebSourceDat5.useRecaptcha) || false), _defineProperty(_this$editedWebSource, this.fieldNames.LOCATION_PICKER.DEFAULT_LANGUAGE, ((_this$rawWebSourceDat6 = this.rawWebSourceData) === null || _this$rawWebSourceDat6 === void 0 ? void 0 : (_this$rawWebSourceDat7 = _this$rawWebSourceDat6.locationPicker) === null || _this$rawWebSourceDat7 === void 0 ? void 0 : _this$rawWebSourceDat7.defaultLanguage) || this.defaultLanguage), _defineProperty(_this$editedWebSource, this.fieldNames.LOCATION_PICKER.LOCATION_PICKER_TEXT, ((_this$rawWebSourceDat8 = this.rawWebSourceData) === null || _this$rawWebSourceDat8 === void 0 ? void 0 : (_this$rawWebSourceDat9 = _this$rawWebSourceDat8.locationPicker) === null || _this$rawWebSourceDat9 === void 0 ? void 0 : _this$rawWebSourceDat9.locationPickerText) || {}), _defineProperty(_this$editedWebSource, this.fieldNames.LOCATION_PICKER.LOCATION_GROUP_PICKER_TEXT, ((_this$rawWebSourceDat10 = this.rawWebSourceData) === null || _this$rawWebSourceDat10 === void 0 ? void 0 : (_this$rawWebSourceDat11 = _this$rawWebSourceDat10.locationPicker) === null || _this$rawWebSourceDat11 === void 0 ? void 0 : _this$rawWebSourceDat11.locationGroupPickerText) || {}), _defineProperty(_this$editedWebSource, this.fieldNames.LOCATION_PICKER.LOCATION_GROUP_PICKER_ENABLED, ((_this$rawWebSourceDat12 = this.rawWebSourceData) === null || _this$rawWebSourceDat12 === void 0 ? void 0 : (_this$rawWebSourceDat13 = _this$rawWebSourceDat12.locationPicker) === null || _this$rawWebSourceDat13 === void 0 ? void 0 : _this$rawWebSourceDat13.locationGroupPickerEnabled) || false), _defineProperty(_this$editedWebSource, this.fieldNames.LOCATION_PICKER.LOGO_BRIGHT, ((_this$rawWebSourceDat14 = this.rawWebSourceData) === null || _this$rawWebSourceDat14 === void 0 ? void 0 : (_this$rawWebSourceDat15 = _this$rawWebSourceDat14.locationPicker) === null || _this$rawWebSourceDat15 === void 0 ? void 0 : _this$rawWebSourceDat15.logoBright) || null), _defineProperty(_this$editedWebSource, this.fieldNames.LOCATION_PICKER.LOGO_DARK, ((_this$rawWebSourceDat16 = this.rawWebSourceData) === null || _this$rawWebSourceDat16 === void 0 ? void 0 : (_this$rawWebSourceDat17 = _this$rawWebSourceDat16.locationPicker) === null || _this$rawWebSourceDat17 === void 0 ? void 0 : _this$rawWebSourceDat17.logoDark) || null), _defineProperty(_this$editedWebSource, this.fieldNames.LOCATION_PICKER.BACKGROUND_IMAGE, ((_this$rawWebSourceDat18 = this.rawWebSourceData) === null || _this$rawWebSourceDat18 === void 0 ? void 0 : (_this$rawWebSourceDat19 = _this$rawWebSourceDat18.locationPicker) === null || _this$rawWebSourceDat19 === void 0 ? void 0 : _this$rawWebSourceDat19.backgroundImage) || null), _this$editedWebSource);
    },
    submitForm: function submitForm() {
      this.isSubmitting = true;
      this.validationErrorOccurred = false;
      this.serverErrorOccurred = false;
      this.successfullySaved = false;
      this.validationErrors = [];

      // Replace empty strings with null
      for (var _i = 0, _Object$entries = Object.entries(this.editedWebSourceData); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          propertyKey = _Object$entries$_i[0],
          propertyValue = _Object$entries$_i[1];
        if (typeof propertyValue === 'string' && propertyValue.trim() === '') {
          this.editedWebSourceData[propertyKey] = null;
        }
      }
      var webSourceDTO = this.getWebSourceDTO(this.editedWebSourceData);
      if (webSourceDTO.locationPicker) {
        this.validateLas(webSourceDTO);
      }
      if (this.validationErrorOccurred) {
        this.isSubmitting = false;
        this.validationErrorOccurred = false;
        return;
      }
      if (!this.sourceId) {
        WebSourceManagement.createWebSource(this.$store.state.general.companyId, webSourceDTO).then(this.onSubmissionSuccess, this.onSubmissionError);
      } else {
        WebSourceManagement.updateWebSource(this.$store.state.general.companyId, webSourceDTO).then(this.onSubmissionSuccess, this.onSubmissionError);
      }
    },
    onSubmissionSuccess: function onSubmissionSuccess() {
      var _this4 = this;
      if (this.isCreation) {
        setTimeout(function () {
          _this4.$router.push({
            name: 'web-source-management'
          });
        }, 1000);
      }
      this.isSubmitting = false;
      this.successfullySaved = true;
      ScrollAnimatorService.scrollToTopOfElement(this.$el);
    },
    onSubmissionError: function onSubmissionError(error) {
      var data = error.response.data;
      var errorCode = data.status.code;
      var payload = data.payload;
      if (errorCode === 400 && payload !== null && payload.length > 0) {
        this.validationErrorOccurred = true;
        this.validationErrors = payload;
      } else {
        this.serverErrorOccurred = true;
      }
      this.isSubmitting = false;
      ScrollAnimatorService.scrollToTopOfElement(this.$el);
    },
    getWebSourceDTO: function getWebSourceDTO(formData) {
      var _formData$this$fieldN;
      var locationPickerDTO = null;
      if ((formData === null || formData === void 0 ? void 0 : (_formData$this$fieldN = formData[this.fieldNames.LOCATIONS]) === null || _formData$this$fieldN === void 0 ? void 0 : _formData$this$fieldN.length) > 1) {
        locationPickerDTO = {
          locationGroupPickerEnabled: formData[this.fieldNames.LOCATION_PICKER.LOCATION_GROUP_PICKER_ENABLED] || false,
          locationGroupPickerText: formData[this.fieldNames.LOCATION_PICKER.LOCATION_GROUP_PICKER_TEXT],
          locationPickerText: formData[this.fieldNames.LOCATION_PICKER.LOCATION_PICKER_TEXT],
          defaultLanguage: formData[this.fieldNames.LOCATION_PICKER.DEFAULT_LANGUAGE],
          logoDark: formData[this.fieldNames.LOCATION_PICKER.LOGO_DARK],
          logoBright: formData[this.fieldNames.LOCATION_PICKER.LOGO_BRIGHT],
          backgroundImage: formData[this.fieldNames.LOCATION_PICKER.BACKGROUND_IMAGE]
        };
      }
      return {
        webSourceId: formData[this.fieldNames.WEB_SOURCE_ID],
        description: formData[this.fieldNames.DESCRIPTION],
        locationIds: formData[this.fieldNames.LOCATIONS],
        useRecaptcha: formData[this.fieldNames.USE_RECAPTCHA],
        embeddedType: formData[this.fieldNames.EMBEDDED_TYPE],
        enabledLanguages: this.activeSurveyLanguages,
        locationPicker: locationPickerDTO
      };
    },
    validateLas: function validateLas(dto) {
      var _dto$locationPicker, _dto$locationPicker2;
      if ((_dto$locationPicker = dto.locationPicker) !== null && _dto$locationPicker !== void 0 && _dto$locationPicker.locationPickerText) {
        var _getValidationState = getValidationState(dto.locationPicker.locationPickerText, dto.enabledLanguages),
          valid = _getValidationState.valid;
        if (!valid) {
          this.checkForExistingValidationErrors(this.fieldNames.LOCATION_PICKER.LOCATION_PICKER_TEXT);
        }
      }
      if (dto.locationPicker.locationGroupPickerEnabled && (_dto$locationPicker2 = dto.locationPicker) !== null && _dto$locationPicker2 !== void 0 && _dto$locationPicker2.locationGroupPickerText) {
        var _getValidationState2 = getValidationState(dto.locationPicker.locationGroupPickerText, dto.enabledLanguages),
          _valid = _getValidationState2.valid;
        if (!_valid) {
          this.checkForExistingValidationErrors(this.fieldNames.LOCATION_PICKER.LOCATION_GROUP_PICKER_TEXT);
        }
      }
      if (dto.locationPicker.locationGroupPickerEnabled && !dto.locationPicker.locationGroupPickerText) {
        this.checkForExistingValidationErrors(this.fieldNames.LOCATION_PICKER.LOCATION_GROUP_PICKER_TEXT);
      }
    },
    createValidationError: function createValidationError(fieldName) {
      this.validationErrorOccurred = true;
      this.validationErrors.push({
        errorType: ERROR_TYPES.FIELD_REQUIRED,
        fields: [fieldName]
      });
    },
    addValidationError: function addValidationError(fieldName) {
      this.validationErrors.map(function (error) {
        if (error.errorType === ERROR_TYPES.FIELD_REQUIRED) {
          error.fields.push(fieldName);
        }
      });
    },
    checkForExistingValidationErrors: function checkForExistingValidationErrors(fieldName) {
      return this.validationErrors.some(function (error) {
        return error.errorType === ERROR_TYPES.FIELD_REQUIRED;
      }) ? this.addValidationError(fieldName) : this.createValidationError(fieldName);
    }
  }
};